import type { ReactNode } from "react";

export function SectionCard({
	title,
	dataComponent,
	children,
	footer,
}: {
	title: string;
	dataComponent: string;
	children: ReactNode;
	footer?: ReactNode;
}) {
	return (
		<section data-component={dataComponent} className="surface-panel flex h-full flex-col">
			<h2 className="panel-heading type-section-title text-foreground">{title}</h2>

			<div className="panel-body flex-1">{children}</div>

			{footer !== undefined && <div className="border-t border-border p-4 sm:px-5">{footer}</div>}
		</section>
	);
}
